import { createSlice } from '@reduxjs/toolkit';
import { ExerciseFormValues } from 'pages/TemplatesPage/ExerciseCreation/types';

const initialState: ExerciseFormValues = {
  name: '',
  shortDescription: '',
  difficulty: 'BEGINNER',
  durationMinutes: 0,
  durationSeconds: 0,
  instructions: [{ order: 1, description: '' }],
  benefits: [{ description: '' }],
  slug: undefined,
  status: 'DRAFT',
};

const slice = createSlice({
  name: 'exercise',
  initialState,
  reducers: {
    returnToDefaultValues: () => initialState,
    setExerciseData: (state, { payload }: { payload: ExerciseFormValues }) =>
      payload,
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
